import { cva } from "class-variance-authority";

import { PlanningType as PlanningTypeEnum } from "@eisox/api/core-api";

import { m } from "~/paraglide/messages";

import { planningTypeKeyMessages as planningTypeKeyMessagesHelper } from "../helpers/planning.helper";

export type PlanningType = PlanningTypeEnum | "userDefined";

const planningTypeKeyVariant = cva(
  "flex items-center gap-[5px] text-base text-primary-dark-blue before:mr-[10px] before:inline-block before:h-[16px] before:w-[16px] before:shrink-0 before:rounded-[2px] before:align-middle before:content-[''] [&_span]:text-sm [&_span]:text-primary-dark-gray",
  {
    variants: {
      type: {
        occupation: "before:bg-planning-comfort",
        inoccupation: "before:bg-planning-absence",
        thermalShock:
          "before:[background:repeating-linear-gradient(135deg,#e4a46a,#e4a46a_1px,var(--planning-comfort-color)_1px,var(--planning-comfort-color)_5px)]",
        comfort: "before:bg-planning-comfort",
        night: "before:bg-planning-night",
        absence: "before:bg-planning-absence",
        preComfort: "before:bg-planning-pre-comfort",
        enabled: "before:bg-planning-comfort",
        stop: "before:bg-planning-stop",
        userDefined:
          "before:[background:repeating-linear-gradient(135deg,var(--primary-dark-gray-color),var(--primary-dark-gray-color)_1px,var(--primary-white-color)_1px,var(--primary-white-color)_5px)]",
      },
    },
  },
);

const planningTypeKeyMessages: Record<PlanningType, string> = {
  ...planningTypeKeyMessagesHelper,
  userDefined: m.user_planning(),
};

interface PlanningTypeKeyProps extends React.HTMLAttributes<HTMLParagraphElement> {
  type: PlanningType;
  temperature?: number | string;
}

const PlanningTypeKey: React.FC<PlanningTypeKeyProps> = ({ type, temperature, className, ...props }) => {
  return (
    <p {...props} className={planningTypeKeyVariant({ type, className })}>
      {planningTypeKeyMessages[type]} {temperature && <span>{`(${temperature}°C)`}</span>}
    </p>
  );
};

PlanningTypeKey.displayName = "PlanningTypeKey";

export { PlanningTypeKey };
export type { PlanningTypeKeyProps };
